export default __webpack_public_path__ + "img/goal.7a210c34.png";